import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { Button } from '@components/ui/button';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const UpdateSW = () => {
  const { t } = useTranslation('app');
  const [hasUpdate, setHasUpdate] = useState(false);
  const reg = useRef<ServiceWorkerRegistration | null>(null);

  const handleUpdate = () => window.location.reload();

  useEffect(() => {
    const checkReg = async () => {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        // eslint-disable-next-line immutable/no-mutation
        reg.current = registration;
        registration.addEventListener('updatefound', () => {
          setHasUpdate(true);
        });
      }
    };

    checkReg().catch((err) => {
      console.error(err);
    });
  }, []);

  useEffect(() => {
    if (!hasUpdate) return;
    handleUpdate();
  }, [hasUpdate]);

  return (
    <AlertDialog open={hasUpdate}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('navigation.update.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('navigation.update.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button onClick={handleUpdate}>{t('actions.update')}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
